import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=5001d51e"
import script from "./Release.vue?vue&type=script&lang=ts"
export * from "./Release.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports